import { ReactElement, useContext } from "react";
import IconButton from "@mui/material/IconButton";
import { setDarkMode } from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import { IState } from "../../types";
import { useAsyncFetch } from "../../system/useFetch";
import { SystemContext } from "../../context/systemContext";

const ThemeSelector = (): ReactElement => {
  const dispatch = useDispatch<any>();
  const systemContext = useContext(SystemContext);
  const darkMode = useSelector((state: IState) => state.darkMode);
  const [updateUserConfig ] = useAsyncFetch();

  const onClick = () => {

    updateUserConfig({
      module: "security",
      query: "updateUserConfig",
      payload: {
        ...systemContext.user?.config,
        darkMode: !darkMode
      }
    }).then(() => dispatch(setDarkMode(!darkMode)));

  };

  return(
    <IconButton onClick={onClick}>
      {darkMode
        ? <Brightness7Icon fontSize="inherit"/>
        : <Brightness4Icon fontSize="inherit"/>}
    </IconButton>
  );
};


export default ThemeSelector;
